import { Link } from "react-router-dom";

const ThankYouPage = () => {
  return (
    <div className="p-4 text-center">
      <h2 className="text-2xl font-bold mb-4">Thank You!</h2>
      <p>Your submission has been received.</p>
      <Link to="/" className="text-blue-500 mt-4 inline-block">Go Back</Link>
    </div>
  );
};

export default ThankYouPage;
